<i18n>
{
  "fr": {
    "login-title": "Récupérer son mot de passe",
    "login-desc": "Veuillez saisir votre nom d'utilisateur et votre email pour récupérer votre mot de passe. Si les informations correspondent, vous recevrez un email contenant un lien pour définir un nouveau mot de passe.",
    "send": "Envoyer",
    "required-field": "Ce champs est requis",
    "cant-process": "Impossible de traiter la demande pour le moment. Veuillez réessayer plus tard.",
    "login-label": "Votre nom d'utilisateur",
    "email-label": "Votre adresse email",
    "email-sent": "Consultez votre boîte email, un lien pour définir un nouveau mot de passe vous a été envoyé.",
    "not-an-email": "Le format de l'adresse email n'est pas correcte.",
    "wrong-user-error": "Impossible de trouver le compte associé aux informations fournises. Veuillez contrôler votre saisie.",
    "goto-login": "Retour au login"
  },
  "de": {

  }
}
</i18n>

<template>
  <div id="login">
    <div v-if="ie" class="error">
      <p><b>Microsoft Internet Explorer</b></p>
      <p>Vous utilisez Microsoft Internet Explorer pour consulter ce site mais <b>celui-ci n’est pas capable d’afficher correctement son contenu</b>.<br />Veuillez mettre à jour votre navigateur.</p>
    </div>

    <div class="login-form-container">

      <md-card class="connection-form">
        <md-card-header>
          <div class="md-title">{{ $t('login-title') }} <md-icon :class="keyColorClass">vpn_key</md-icon></div>
        </md-card-header>

        <md-card-content v-if="done">
          <p class="login-desc">{{ $t('email-sent') }}</p>
          <router-link to="/login">{{ $t('goto-login') }}</router-link>
        </md-card-content>

        <md-card-content v-if="!done">
          <p class="login-desc">{{ $t('login-desc') }}</p>

          <form v-on:keyup.enter="send">
            <md-field :class="getValidationClass('login')">
              <label>{{ $t('login-label') }}</label>
              <md-input ref="loginInput" :disabled="processing" v-model="login" type="text"></md-input>
              <span class="md-error" v-if="!$v.login.required">{{ $t('required-field') }}</span>
            </md-field>
            <md-field :class="getValidationClass('email')">
              <label>{{ $t('email-label') }}</label>
              <md-input :disabled="processing" v-model="email" type="email"></md-input>
              <span class="md-error" v-if="!$v.email.required">{{ $t('required-field') }}</span>
              <span class="md-error" v-if="!$v.email.email">{{ $t('not-an-email') }}</span>
            </md-field>
          </form>

          <span class="fail-text" v-if="!!fail">{{ fail }}</span>
        </md-card-content>

        <md-card-actions>
          <md-button class="md-raised md-primary" v-if="!done" :disabled="processing" @click="send">{{ $t('send') }}</md-button>
          <md-menu md-direction="bottom-end">
            <md-button md-menu-trigger>{{$t($root.$i18n.locale)}}</md-button>

            <md-menu-content class="md-layout-item md-size-10">
              <md-menu-item @click="$root.$i18n.locale = 'fr'">{{ $t('fr') }}</md-menu-item>
              <md-menu-item @click="$root.$i18n.locale = 'de'">{{ $t('de') }}</md-menu-item>
            </md-menu-content>
          </md-menu>
        </md-card-actions>

      </md-card>

    </div>

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import UAParser from 'ua-parser-js'
import { validationMixin } from 'vuelidate'
import {
  required,
  email
} from 'vuelidate/lib/validators'

import Auth from '@/utils/auth'

import Snackbar from '@/components/common/snackbar'

const useragent = new UAParser()

export default {
  name: 'Login',
  components: {
    Snackbar
  },
  mixins: [validationMixin],
  validations: {
    login: {
      required
    },
    email: {
      required,
      email
    }
  },
  data () {
    return {
      login: '',
      email: '',
      processing: false,
      fail: '',
      done: false
    }
  },
  computed: {
    browser () {
      return useragent.getBrowser()
    },
    ie () {
      return this.browser.name === 'IE'
    },
    edge () {
      return this.browser.name === 'Edge' && parseInt(this.browser.major, 10) < 76
    },
    keyColorClass () {
      if (!this.processing && !this.fail) return 'md-primary'
      if (this.fail !== '') return 'md-accent'
      return ''
    }
  },
  mounted () {
    this.focusLoginField()
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    isFormValid () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    focusLoginField () {
      setTimeout(() => {
        this.$refs.loginInput.$el.focus()
      }, 100)
    },
    send () {
      if (this.isFormValid()) {
        this.done = false
        this.processing = true
        this.fail = ''

        Auth.forgotPassword(this.login, this.email).then(() => {
          this.processing = false
          this.done = true
        }).catch((error) => {
          this.processing = false
          if (error.response.status === 422) this.fail = this.$t('wrong-user-error')
          else this.handleError(error.toString())
        })
      }
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style scoped lang="scss">
  .login-desc {
    margin-top: 0;
  }

  .error {
    background-color: #ff9191
  }

  .fail-text {
    padding-top: 15px;
    color: #ff1744;
    display: block;
  }

  .login-form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 120px);
  }

  .connection-form {
    max-width: 500px;
  }

  .help-go-form {
    padding: 15px;
  }
</style>
